import { render } from "./VideoBrowsingHistory.vue?vue&type=template&id=e1e49d76&ts=true"
import script from "./VideoBrowsingHistory.vue?vue&type=script&lang=ts"
export * from "./VideoBrowsingHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__